// src/pages/Employee/ViewEmployee.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import employeeService from '../../services/employee.service';
import Toast from '../../components/Toast/Toast';
import '../../styles/AddPages.css';

const Field = ({ label, value }) => (
  <div className="form-group">
    <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>{label}</label>
    <div className="form-input" style={{
      background: '#f8f9fa', cursor: 'default',
      minHeight: 42, display: 'flex', alignItems: 'center',
    }}>
      {value || <span style={{ color: '#aaa' }}>—</span>}
    </div>
  </div>
);

const ViewEmployee = () => {
  const { id }   = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [toast,    setToast]    = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await employeeService.getEmployeeById(id);
        if (res.success) setEmployee(res.data);
      } catch {
        setToast({ message: 'Failed to fetch employee details', type: 'error' });
      } finally { setLoading(false); }
    };
    fetch();
  }, [id]);

  if (loading) return <div className="add-employee-page"><p style={{ padding: 40 }}>Loading...</p></div>;
  if (!employee) return <div className="add-employee-page"><p style={{ padding: 40 }}>Employee not found.</p></div>;

  const fullName = `${employee.firstName} ${employee.lastName}`;

  return (
    <div className="add-employee-page">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/dashboard/overview">Dashboard</a></li>
          <li className="breadcrumb-item"><a href="/employee/view">Employees</a></li>
          <li className="breadcrumb-item active">View Employee</li>
        </ol>
      </nav>

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 className="page-title">Employee Details</h4>
        <button className="btn btn-primary" onClick={() => navigate(`/employee/edit/${id}`)}>
          ✏️ Edit Employee
        </button>
      </div>

      <div className="form-card">

        {/* Basic Info */}
        <div className="form-section">
          <div className="form-row">
            <Field label="Full Name"      value={fullName} />
            <Field label="Employee Code"  value={employee.employeeCode} />
            <Field label="Role"           value={employee.role?.displayName || employee.role?.name} />
          </div>
          <div className="form-row">
            <Field label="Email"    value={employee.email} />
            <Field label="Mobile"   value={employee.phone} />
            <Field label="Username" value={employee.username} />
          </div>
          <div className="form-row">
            <Field label="Status" value={employee.status} />
            <Field label="Reporting To"
              value={employee.reportingManager
                ? `${employee.reportingManager.firstName} ${employee.reportingManager.lastName} (${employee.reportingManager.role?.displayName})`
                : null}
            />
          </div>
        </div>

        {/* Area Assignment */}
        <div className="form-section">
          <h3 style={{ color:'#4caf50', fontSize:13, fontWeight:700, marginBottom:16,
            textTransform:'uppercase', letterSpacing:'0.5px' }}>
            📍 Area Assignment
          </h3>
          <div className="form-row">
            <Field label="Region"          value={employee.region?.name} />
            <Field label="Headquarter"     value={employee.headquarter?.name} />
            <Field label="Sub-Headquarter" value={employee.subHeadquarter?.name} />
          </div>
          <div className="form-row">
            <Field label="Godown" value={employee.godown?.name} />
          </div>
        </div>

        {/* Allowances */}
        <div className="form-section">
          <h3 style={{ color:'#4caf50', fontSize:13, fontWeight:700, marginBottom:16,
            textTransform:'uppercase', letterSpacing:'0.5px' }}>
            💰 Allowances
          </h3>
          <div className="form-row">
            <Field label="DA (Dearness Allowance)" value={employee.DA     ? `₹${employee.DA}`     : null} />
            <Field label="Bike TA"                 value={employee.bikeTA ? `₹${employee.bikeTA}` : null} />
            <Field label="Car TA"                  value={employee.carTA  ? `₹${employee.carTA}`  : null} />
          </div>
        </div>

        <div className="form-actions">
          <button className="btn btn-secondary" onClick={() => navigate('/employee/view')}>
            ← Back to List
          </button>
          <button className="btn btn-primary" onClick={() => navigate(`/employee/edit/${id}`)}>
            ✏️ Edit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewEmployee;